var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitIconLayerInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#287cff",
    cx: 7,
    cy: 7,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.8418 3.81641C7.8418 4.28369 7.46045 4.63818 6.99316 4.63818C6.53125 4.63818 6.1499 4.28369 6.1499 3.81641C6.1499 3.34912 6.53125 3 6.99316 3C7.46045 3 7.8418 3.34912 7.8418 3.81641ZM7.77734 5.28271V11.1963H6.20898V5.28271H7.77734Z"
  })));
}
export default SvgVisitIconLayerInfo;